module.exports = __webpack_public_path__ + "img/article-image-2.801a67e5.jpeg";